module.exports = __webpack_public_path__ + "img/pn.16e98c23.svg";